import styled from 'styled-components';

export const SubMenuAudioUploadWrapper = styled.div`
  position: absolute;
  left: 57px;
  top: 90px;
  bottom: 50px;
  background: #fff;
  z-index: 2;
  box-shadow: 0px 4px 6px #abc1ddb3;
  border-radius: 15px;
  width: 400px;
  transform: translateX(-100%);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  &.open {
    transform: translateX(28px);
  }

  .header {
    padding: 16px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    h3 {
      font-size: 16px;
      font-weight: normal;
      color: #515f75;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    label {
      margin: 0;
      cursor: pointer;
    }

    input {
      display: none;
    }
  }

  .container-input-search {
    display: flex;
    margin: 0px 18px 15px;
  }

  .input-search {
    height: 30px;
    width: 100%;
    background: #e9ebee;
    border-radius: 5px;
    padding: 0 6px;
    font-size: 14px;
    border: 0;
    color: #515f75;
  }
`;

export const TableAudioUploadedWrapper = styled.div`
  overflow-y: auto;
  max-height: calc(100% - 140px);

  table {
    width: 100%;
  }

  thead th {
    color: #515f75;
    font-size: 16px;
    padding: 0px 20px 5px;
  }

  tbody {
    tr:nth-of-type(odd) {
      background-color: #f2f2f2;
    }

    td {
      font-size: 14px;
      font-weight: normal;
      padding: 3px 20px;
      word-break: break-all;
    }

    td:first-of-type {
      width: 256px;
    }
  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    color: #008dfa;
    font-size: 14px;
    padding: 0;

    :first-of-type {
      margin-right: 26px;
      width: 34px;
    }
  }
`;
